const getRandomInt = (maxValue) => {
  return Math.floor(Math.random() * (maxValue + 1));
};

export default getRandomInt;
